import { render, staticRenderFns } from "./ExpedienteDetailView.vue?vue&type=template&id=1aeb1610&scoped=true&"
import script from "./ExpedienteDetailView.vue?vue&type=script&lang=js&"
export * from "./ExpedienteDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ExpedienteDetailView.vue?vue&type=style&index=0&id=1aeb1610&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aeb1610",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VSpacer,
  VToolbar,
  VToolbarTitle,
})
